(function () {
  var msg = document.getElementById('twh-message');
  var per = document.querySelector('.twh-personalize');
  if (!msg || !per) return;
  var FID = msg.getAttribute('form');
  if (!FID) return;

  /* Hero carry-over, part two. The theme.liquid bridge applies message +
     handwriting from twh_prefill; this applies the signature and anonymity the
     buyer set in the hero (twh_prefill2), once, within 30 minutes, without
     overwriting anything already typed. Separate key so the two bridges never
     race over who clears what. */
  try {
    var p2 = JSON.parse(localStorage.getItem('twh_prefill2') || 'null');
    if (p2 && p2.ts && (Date.now() - p2.ts) < 1800000) {
      var sg = document.getElementById('twh-signas');
      if (sg && p2.sign && !sg.value) { sg.value = p2.sign; sg.dispatchEvent(new Event('input', {bubbles: true})); }
      var an = document.querySelector('input[name="properties[Anonymous]"]');
      if (an && p2.anon && !an.checked) { an.checked = true; an.dispatchEvent(new Event('change', {bubbles: true})); }
      localStorage.removeItem('twh_prefill2');
    }
  } catch (e) {}

  /* Format-aware message limit. EMPIRICAL, not Cardly's estimate: a
     660-character message overflowed a folded card on 2026-07-27, so the caps
     are 500 characters for a folded card and 1,500 for an A4 letter, enforced
     here AND in the fulfilment run so nothing the buyer drafts can outrun the
     pen. Do not raise these without a verified print test. */
  var CFG = window.TWH_DELIVERY || {};
  var CAP = CFG.cap || 500;
  var ISLETTER = !!CFG.isLetter;
  msg.maxLength = CAP;
  var count = document.createElement('p');
  count.className = 'twh-count';
  count.setAttribute('aria-live', 'polite');
  msg.insertAdjacentElement('afterend', count);
  function updCount() {
    var n = msg.value.length;
    count.textContent = n.toLocaleString() + ' of ' + CAP.toLocaleString() +
      ' characters' + (ISLETTER ? ', a letter holds about 300 words' : ', this card holds about 200 words');
    count.classList.toggle('twh-count-hot', n > CAP * 0.9);
  }
  msg.addEventListener('input', updCount);
  updCount();

  /* Preview handwriting moved to snippets/twh-personalize-js.liquid + assets/twh-hand.js (2026-08-30). */

  if (ISLETTER) {
    /* The product template's fixed copy assumes a folded card. Reword it. */
    var sz = document.querySelector('.twh-intro-size span');
    if (sz) sz.innerHTML = '<strong>A4 letter, 210 x 297 mm.</strong> Your message is written down the page in real ink, and it arrives in its own envelope.';
    var lbl = document.querySelector('label[for="twh-message"] span');
    if (lbl) lbl.textContent = 'written down the page, in real ink';
    var pvt = document.querySelector('.twh-pv-title span');
    if (pvt) pvt.textContent = 'tap it to read it';
    var pvn = document.querySelector('.twh-pv-note');
    if (pvn) pvn.textContent = 'Live preview of exactly what we mail: your words written down this page with a real pen, sent in its own envelope.';
  }

  var STATES = ['AL','AK','AZ','AR','CA','CO','CT','DE','DC','FL','GA','HI','ID','IL','IN','IA','KS','KY','LA','ME','MD','MA','MI','MN','MS','MO','MT','NE','NV','NH','NJ','NM','NY','NC','ND','OH','OK','OR','PA','RI','SC','SD','TN','TX','UT','VT','VA','WA','WV','WI','WY'];

  /* 2026-08-15: the delivery block is now SERVER RENDERED by
     snippets/twh-personalize.liquid, so it is in the served HTML, present on
     first paint, and posts correctly even if this file never loads. Building it
     here meant the single most important control on the page, where the card
     actually goes, did not exist for crawlers, for the first paint, or for any
     buyer whose JavaScript failed, who could then order a card with no
     recipient address at all.

     ADOPT IT IF IT IS THERE, BUILD IT IF IT IS NOT. The fallback below is the
     exact markup this script shipped before, kept so an older or hand-edited
     product template can never leave the page without a delivery choice. Do not
     delete it, and if you change the markup, change BOTH. */
  var wrap = per.querySelector('#twh-deliver');
  var ssr = !!wrap;

  if (!ssr) {
    wrap = document.createElement('fieldset');
    wrap.className = 'twh-deliver';
    wrap.id = 'twh-deliver';
    wrap.innerHTML =
      '<legend class="twh-label">Where should we mail it?</legend>' +
      '<label class="twh-dl-opt"><input type="radio" name="properties[Mail to]" value="Straight to them" checked>' +
      '<span><strong>Straight to them</strong>We stamp it and mail it to their mailbox.</span></label>' +
      '<label class="twh-dl-opt"><input type="radio" name="properties[Mail to]" value="To me first">' +
      '<span><strong>To me first</strong>We mail it to you, so you can hand it over in person.</span></label>' +
      '<div class="twh-dl-fields">' +
        '<div class="twh-dl-full"><label class="twh-label" for="twh-dl-name">Recipient name</label>' +
        '<input id="twh-dl-name" type="text" name="properties[Recipient name]" autocomplete="off" maxlength="60" placeholder="Who is this going to?"></div>' +
        '<div class="twh-dl-full twh-dl-addrwrap"><label class="twh-label" for="twh-dl-addr">Street address <span>start typing, then pick from the list</span></label>' +
        '<input id="twh-dl-addr" type="text" name="properties[Recipient address]" autocomplete="off" maxlength="80" placeholder="123 Main St"></div>' +
        '<div class="twh-dl-full"><label class="twh-label" for="twh-dl-addr2">Apt or unit <span>optional</span></label>' +
        '<input id="twh-dl-addr2" type="text" name="properties[Recipient apt/unit]" autocomplete="off" maxlength="40"></div>' +
        '<div class="twh-dl-row">' +
          '<div><label class="twh-label" for="twh-dl-city">City</label>' +
          '<input id="twh-dl-city" type="text" name="properties[Recipient city]" autocomplete="off" maxlength="40"></div>' +
          '<div class="twh-dl-st"><label class="twh-label" for="twh-dl-state">State</label>' +
          '<select id="twh-dl-state" name="properties[Recipient state]"><option value="" selected disabled>--</option></select></div>' +
          '<div class="twh-dl-zip"><label class="twh-label" for="twh-dl-zip">ZIP</label>' +
          '<input id="twh-dl-zip" type="text" inputmode="numeric" name="properties[Recipient ZIP]" autocomplete="off" maxlength="10" pattern="\\d{5}(-\\d{4})?" title="5 digit ZIP, or ZIP+4"></div>' +
        '</div>' +
      '</div>' +
      '<p class="twh-dl-note" hidden>No address needed here. You will enter your own mailing address at checkout, and we will send the card to you, ready to hand over in person.</p>' +
      '<div class="twh-dl-full twh-dl-arrive"><label class="twh-label" for="twh-dl-arrive">When should it arrive?</label>' +
      '<input id="twh-dl-arrive" type="date" name="properties[Arrive by]">' +
      '<p class="twh-dl-arrivenote">Optional. We will time the mailing so it lands close to this date. Exact day not guaranteed.</p></div>';
  }

  /* The state list is server rendered too. Only fill it when it is empty, so
     the fallback path above still gets a usable dropdown. */
  var sel = wrap.querySelector('#twh-dl-state');
  if (sel && sel.options.length < 2) {
    STATES.forEach(function (s) {
      var o = document.createElement('option');
      o.value = s; o.textContent = s;
      sel.appendChild(o);
    });
  }

  /* Every input posts with the product form, exactly like the personalize fields.
     Server rendered markup already carries this; setting it again is harmless and
     keeps the fallback path identical. */
  [].forEach.call(wrap.querySelectorAll('input,select'), function (el) {
    el.setAttribute('form', FID);
  });

  /* Optional arrival date. Bounds are computed here in the buyer's own
     timezone, not in Liquid: six days out covers writing plus USPS transit,
     a year out is the sanity ceiling. Recomputed on focus so a tab left open
     past midnight never offers a stale window. Lives outside .twh-dl-fields
     on purpose: it applies to both mailing choices, so toggle() must not
     disable it. */
  var arrive = wrap.querySelector('#twh-dl-arrive');
  function arriveISO(days) {
    var t = new Date();
    t.setDate(t.getDate() + days);
    var mo = t.getMonth() + 1, da = t.getDate();
    return t.getFullYear() + '-' + (mo < 10 ? '0' + mo : mo) + '-' + (da < 10 ? '0' + da : da);
  }
  function arriveBounds() {
    if (!arrive) return;
    arrive.min = arriveISO(6);
    arrive.max = arriveISO(365);
  }
  if (arrive) arrive.addEventListener('focus', arriveBounds);
  arriveBounds();

  var mailbox = per.querySelector('.twh-mailbox');
  if (!ssr) {
    if (mailbox) { per.insertBefore(wrap, mailbox); } else { per.appendChild(wrap); }
  }
  if (mailbox) {
    mailbox.innerHTML = '<strong>How mailing works</strong><br>' +
      'Choose above where the card should go. At checkout, enter your own name and ' +
      'address, so the order and receipt belong to you. We write your message in ' +
      'real ink, stamp the envelope, and mail the card in 1 to 3 business days.';
  }

  var fields = wrap.querySelector('.twh-dl-fields');
  var note = wrap.querySelector('.twh-dl-note');
  var req = ['twh-dl-name', 'twh-dl-addr', 'twh-dl-city', 'twh-dl-state', 'twh-dl-zip'];
  function toggle() {
    var toThem = wrap.querySelector('input[value="Straight to them"]').checked;
    fields.style.display = toThem ? '' : 'none';
    if (note) note.hidden = toThem;
    [].forEach.call(fields.querySelectorAll('input,select'), function (el) {
      el.disabled = !toThem;
      if (req.indexOf(el.id) !== -1) el.required = toThem;
    });
  }
  wrap.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'properties[Mail to]') toggle();
  });
  toggle();

  /* Handed to twh-delivery-address.js, which loads next. Split out because a
     single theme file over 20,000 bytes is silently truncated on write. */
  window.TWH_DELIVERY_CTX = { wrap: wrap, sel: sel, fields: fields };
})();
